import type { ModelKey } from "@/modules/model/model.type";
import type { ReactNode } from "react";

import { useTranslation } from "react-i18next";

import { useAuthorization } from "@/modules/authorization";
import { useSidePanel } from "@/modules/side-panel";

export const useModelDuplicateSidePanel = (modelKey: ModelKey) => {
  const { t } = useTranslation();
  const { openSidePanel } = useSidePanel();
  const { canCreate } = useAuthorization();

  const openDuplicate = (form: ReactNode) => {
    if (!canCreate(modelKey)) return;

    openSidePanel({
      title: t("global:duplicate"),
      component: form,
    });
  };

  return { openDuplicate };
};
